import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IChart } from "src/shared/models/IDashboards.models";

interface DashboardState {
  dashboards: IChart | null;
  dashboardToEdit: IChart | null;
}

const initialState: DashboardState = {
  dashboards: null as any,
  dashboardToEdit: null,
};

const dashboardSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    setDashboardList: (state, action: PayloadAction<IChart| null>) => {
      state.dashboards = action.payload;
    },
    setDashboardToEdit: (state, action: PayloadAction<IChart | null>) => {
      state.dashboardToEdit = action.payload;
    },
  },
});

export const {
  setDashboardList,
  setDashboardToEdit,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
